<template>
  <v-container>
    <v-row>
      <v-col>
        <v-container class="price-table">
          <v-row justify="start" align="start" align-content="start">
            <v-col>{{$t('common:building')}}</v-col>
            <v-col>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <span
                        v-bind="attrs"
                        v-on="on"
                    >
                      {{$t('common:cost')}}*
                    </span>
                </template>
                <span>{{$t('book/facility:cost-analysis.cost-without-vat')}}</span>
              </v-tooltip>
            </v-col>
            <v-col>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <span
                        v-bind="attrs"
                        v-on="on"
                    >
                      {{$t('book/facility:cost-analysis.actual-cost')}}*
                    </span>
                </template>
                <span>{{$t('book/facility:cost-analysis.cost-without-vat')}}</span>
              </v-tooltip>
            </v-col>
            <v-col>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <span
                        v-bind="attrs"
                        v-on="on"
                    >
                      {{$t('common:difference')}}*
                    </span>
                </template>
                <span>{{$t('book/facility:cost-analysis.cost-without-vat')}}</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row justify="start" align="start" align-content="start" v-for="(building, index) in buildings" :key="building.name + index">
            <v-col><a :href="getBuildingUrl(building.objId) + '#analysis'" target="_blank">{{ building.name }}</a></v-col>
            <v-col>{{ building.cost }}</v-col>
            <v-col>{{building.actualCost}}</v-col>
            <v-col><div :class="getClassColor(building)">{{(building.actualCost - building.cost).toFixed(2)}}</div></v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col>
        <v-container>
          <v-row>
            <v-col>
              {{$t('book/facility:cost-analysis.total-cost-without-vat')}}
            </v-col>
            <v-col class="primary--text">
              {{totalCost.toFixed(2)}}
            </v-col>
          </v-row>
          <v-row>
            <v-col >
              {{$t('book/facility:cost-analysis.total-cost-with-vat')}}
            </v-col>
            <v-col class="primary--text">
              {{(totalCost + totalVat).toFixed(2)}}
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              {{$t('book/facility:cost-analysis.vat')}}
            </v-col>
            <v-col class="primary--text">
              {{totalVat.toFixed(2)}}
            </v-col>
          </v-row>
          <v-row justify="end">
            <v-col md="1">
              <v-btn
                  elevation="2"
                  icon
                  outlined
                  color="primary"
                  @click="isPieChart = !isPieChart"
              >
                <v-icon> {{isPieChart ? 'bar_chart' : 'pie_chart'}} </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="isPieChart && showChart">
            <v-col>
              <h3>{{this.$t('common:cost')}}</h3>
              <VueApexCharts width="500" type="pie" :options="pieChartOptions" :series="pieSeries"></VueApexCharts>
            </v-col>
          </v-row>
          <v-row v-if="isPieChart && showChart">
            <v-col>
              <h3>{{this.$t('book/facility:cost-analysis.actual-cost')}}</h3>
              <VueApexCharts width="500" type="pie" :options="pieChartOptions" :series="pieManualSeries"></VueApexCharts>
            </v-col>
          </v-row>
          <v-row v-if="!isPieChart && showChart">
            <v-col>
              <VueApexCharts height="350" type="bar" :options="barChartOptions" :series="barSeries"></VueApexCharts>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

import VueApexCharts from 'vue-apexcharts';
import CostAnalysisService from '@/modules/book/services/cost-analysis-service';
import Utils from "@/modules/core/services/utils";

export default {
  name: 'BuildingCostAnalysisTab',
  components: {VueApexCharts},
  data() {
    return {
      isPieChart: true,
      pieSeries: [],
      pieManualSeries: [],
      barSeries: [],
      pieChartOptions: {
        chart: {
          width: 350,
        },
        labels: [],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },
      barChartOptions: {
        chart: {
          height: 450
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          title: {
            text: '€'
          }
        },
        fill: {
          opacity: 1
        }
      },
      buildings: [
      ],
      showChart: false,
      totalVat: 0,
      totalCost: 0
    }
  },
  computed: {
    loggedInCustomer() {
      return this.$store.state.auth.profile.customer;
    }
  },
  watch: {
    '$store.state.auth.profile.customer': function() {
      this.loadBuildings();
    },
  },
  methods: {
    loadBuildings() {
      if (!this.loggedInCustomer) return;

      this.showChart = false;
      CostAnalysisService.readCustomerAnalysis(this.loggedInCustomer,
          (response) => {
            this.fillAnalysis(response.data);
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure',
                {name: this.$t('book/facility:cost-analysis.cost-analysis')}));
          }
      );
    },
    clearCharts() {
      this.pieSeries = [];
      this.pieManualSeries = [];
      this.pieChartOptions.labels = [];
      this.barChartOptions.xaxis.categories = [];
      this.barSeries = [];
      this.totalVat = 0;
      this.totalCost = 0;
    },
    getClassColor(item) {
      let costDifferenceClass = 'cost-difference '
      costDifferenceClass += item.actualCost - item.cost > 0 ? 'red' : 'green';
      return costDifferenceClass;
    },
    fillAnalysis(custommerAnalysis) {
      let cost = [];
      let manual = [];
      this.clearCharts();

      for(let i = 0; i < custommerAnalysis.length; i++) {
        this.pieChartOptions.labels.push(custommerAnalysis[i].name);
        this.pieSeries.push(parseFloat(custommerAnalysis[i].cost));
        this.pieManualSeries.push(parseFloat(custommerAnalysis[i].actualCost));
        cost.push(parseFloat(custommerAnalysis[i].cost));
        manual.push(parseFloat(custommerAnalysis[i].actualCost));
        this.barChartOptions.xaxis.categories.push(custommerAnalysis[i].name)
        this.setBuilding(custommerAnalysis[i]);
        this.totalCost += parseFloat(custommerAnalysis[i].cost);
        this.totalVat += parseFloat(custommerAnalysis[i].totalVat);
      }

      this.barSeries.push({name: this.$t('common:cost'), data: cost});
      this.barSeries.push({name: this.$t('book/facility:cost-analysis.actual-cost'), data: manual});
      this.showChart = true;
    },
    setBuilding(custommerAnalysis) {
      this.buildings.push({
        name: custommerAnalysis.name,
        cost: parseFloat(custommerAnalysis.cost).toFixed(2),
        actualCost: parseFloat(custommerAnalysis.actualCost).toFixed(2),
        objId: custommerAnalysis.objId
      })
    },
    getBuildingUrl(buildingId) {
      return this.$router.resolve({name: 'AddEditBuilding', params:{id: buildingId}}).href;
    }
  },
  mounted() {
    this.loadBuildings();
  }
}

</script>

<style lang="scss">
.price-table {

  .cost-difference{
    height: 100%;
    width: 50%;
  }

  .actual-cost {
    padding: 0;

    .v-input {
      padding: 0;
      margin: 0;
    }
  }
}
</style>